import { render } from "./News.vue?vue&type=template&id=4cdf5250&scoped=true"
import script from "./News.vue?vue&type=script&setup=true&lang=js"
export * from "./News.vue?vue&type=script&setup=true&lang=js"

import "./News.vue?vue&type=style&index=0&id=4cdf5250&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdf5250"],['__file',"src/core/news/News.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cdf5250"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cdf5250', __exports__)) {
    console.log('reload')
    api.reload('4cdf5250', __exports__)
  }
  
  module.hot.accept("./News.vue?vue&type=template&id=4cdf5250&scoped=true", () => {
    console.log('re-render')
    api.rerender('4cdf5250', render)
  })

}


export default __exports__